import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { CoreState } from 'src/app/state/_state.interfaces';
import { getMessage } from 'src/app/state/_state.selectors';
import { LoginSessions } from 'src/app/state/session.actions';

/**
 * ログイン画面
 */
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent {
  /** メッセージ */
  message$: Observable<string>;

  /**
   * フォームデータ
   */
  loginForm = new FormGroup({
    userID: new FormControl(null, Validators.required),
    password: new FormControl(null, Validators.required)
  });

  /**
   * コンストラクタ
   */
  constructor(
    private store: Store<CoreState>
  ) {
    this.message$ = this.store.select(getMessage);
  }

  /**
   * ログイン
   */
  login() {
    this.store.dispatch(new LoginSessions({
      userId: this.loginForm.value.userID,
      password: this.loginForm.value.password
    }));

    // 「Form submission canceled because ...」のメッセージが出ないようにfalseを返す
    return false;
  }
}
